import cartActionTypes from '../cart/actionTypes';
import createReducer from '../utils/createReducer';

const initialState = {
  cartMods: [],
  itemMods: {},
  itemGroupMods: {},
  cartEnvironmentData: {},
  itemEnvironmentData: {},
  itemGroupEnvironmentData: {},
};

function getProductVersion(productData) {
  if (
    !productData ||
    productData.productVersion === undefined ||
    productData.productVersion === null ||
    typeof productData.productVersion !== 'number'
  ) {
    return -1;
  }
  return productData.productVersion;
}

/**
 * Reducer for 'state.uxMods' portion of Redux state.
 */
export default createReducer(initialState)({
  [cartActionTypes.CART_LOAD_SUCCESS]: (state, action) => {
    // Build itemGroup mod data
    const itemGroupMods = {};
    const itemGroupEnvironmentData = {};
    const { vistacartUrl } = action.cart;
    for (const groupData of action.cart.lineItemGroupData) {
      itemGroupMods[groupData.groupId] = [
        ...((groupData &&
        groupData.customOrderData &&
        groupData.customOrderData.ux
          ? groupData.customOrderData.ux
          : []
        ).filter(x => Object.keys(x).length > 0) || []),
      ];

      const lineItemGroupInfoV1 = {
        groupId: groupData.groupId,
        pricingData: groupData.pricingData || {},
        itemGroupType: groupData.itemGroupType || '',
        groupCustomOrderData: groupData.customOrderData || {},
      };
      // Items belonging to this group will be pushed into this data contract later
      // when building item-level data contracts
      const lineItemGroupRawVistaCartItemsV1 = {
        items: [],
      };
      itemGroupEnvironmentData[groupData.groupId] = {
        lineItemGroupInfoV1,
        lineItemGroupRawVistaCartItemsV1,
      };
    }

    const itemMods = {};
    const itemEnvironmentData = {};
    for (const lineItem of action.cart.lineItems) {
      itemMods[lineItem.id] = [
        ...((lineItem.customOrderData && lineItem.customOrderData.ux).filter(
          x => Object.keys(x).length > 0
        ) || []),
      ];

      // Build itemEnvironmentData
      const lineItemInfoV1 = {
        lineItemId: lineItem.id,
        lineItemCustomOrderData: lineItem.customOrderData,
        lineItemQuantity: lineItem.quantity,
      };
      const lineItemInfoV2 = {
        lineItemId: lineItem.id,
        lineItemCustomOrderData: lineItem.customOrderData,
        lineItemQuantity: lineItem.quantity,
        groupId: lineItem.groupId || '',
        lineItemProduct: {
          productKey: lineItem.productData?.productKey,
          productVersion: getProductVersion(lineItem.productData),
          selectedAttributes: lineItem.productData?.selectedAttributes || [],
        },
      };
      const lineItemInfoV3 = {
        lineItemId: lineItem.id,
        lineItemCustomOrderData: lineItem.customOrderData,
        lineItemQuantity: lineItem.quantity,
        groupId: lineItem.groupId || '',
        lineItemProduct: {
          productKey: lineItem.productData?.productKey,
          productVersion: getProductVersion(lineItem.productData),
          selectedAttributes: lineItem.productData?.selectedAttributes || [],
        },
        itemVersion: lineItem.version,
        itemCorrelationId: lineItem.correlationId || '',
        groupCorrelationId: lineItem.groupCorrelationId || '',
      };

      // Build lineItem Merchandising Data
      const lineItemMerchandisingInfoV1 = {
        merchandisableQuantities:
          lineItem.merchandisingData.merchandisableQuantitiesV2?.list || [],
      };
      const lineItemMerchandisingInfoV2 = {
        merchandisableQuantities:
          lineItem.merchandisingData.merchandisableQuantitiesV2 || {},
      };
      const cartTemplateReference = lineItem.cartTemplateReference || {};
      const cartTemplateRefV1 = {
        hasCartTemplate: !!cartTemplateReference.cartTemplateId,
        cartTemplateId: cartTemplateReference.cartTemplateId || '',
        tenant: cartTemplateReference.tenantName || '',
      };
      itemEnvironmentData[lineItem.id] = {
        lineItemMerchandisingInfoV1,
        lineItemMerchandisingInfoV2,
        lineItemInfoV1,
        lineItemInfoV2,
        lineItemInfoV3,
        cartTemplateRefV1,
      };

      // If this item belongs to a group, push it into appropriate group data contract
      if (lineItem.groupId && itemGroupEnvironmentData[lineItem.groupId]) {
        itemGroupEnvironmentData[
          lineItem.groupId
        ].lineItemGroupRawVistaCartItemsV1.items.push(lineItem);
      }
    }

    return {
      ...state,
      cartMods: [
        ...((action.cart.customOrderData && action.cart.customOrderData.ux) ||
          []),
      ],
      itemMods,
      itemEnvironmentData,
      itemGroupMods,
      itemGroupEnvironmentData,
      cartEnvironmentData: {
        cartInfoV1: {
          vistacartUrl,
          tenant: action.tenant,
          shopperId: action.shopperId,
          cartCustomOrderData: action.cart.customOrderData || {},
          lastModifiedDate: action.cart.lastModifiedAt || '',
          isEmpty: (action.cart.lineItems || []).length === 0,
        },
        shippingDestinationInfoV1: {
          state: action.cart.shippingData?.shippingAddress?.state || '',
          postalCode:
            action.cart.shippingData?.shippingAddress?.postalCode || '',
          country: action.cart.shippingData?.shippingAddress?.country || '',
          isPOBox:
            action.cart.shippingData?.shippingAddress?.metadata?.isPOBox ||
            false,
        },
        siteContextV1: {
          locale: action.locale,
        },
        commonVpDependenciesV1: {
          swan: {
            major: 3,
          },
        },
      },
    };
  },
  [cartActionTypes.CART_CLEAR]: () => initialState,
});
